// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestDirectorySearch-cls1_zCH","cls2":"ResearchInterestDirectorySearch-cls2_GF8 ResearchInterestDirectorySearch-cls1_zCH"};